import { trackEvent } from 'arts/config/analytics';
import Constants from '../config/const';
import { importWallApi, loadFavoriteWallsApi } from '../config/api';
import { loadWorkDetails } from './works';
import { redo } from './undo';
import { resetZoom } from './canvas';
import { whenSaved, pauseSaves, resumeSaves } from './save_wall';

export const loadFavoriteWalls = () => (dispatch, getState) => {
  const { loaded, loading } = getState().favoriteWalls;
  if (loaded || loading) {
    return;
  }
  dispatch({ type: Constants.favoriteWalls.load });
  loadFavoriteWallsApi().then((walls) => {
    dispatch({ type: Constants.favoriteWalls.success, walls });
  }).catch(() => {
    dispatch({ type: Constants.favoriteWalls.success, walls: [] });
  });
};

// import_wall adds wall_pictures server-side, outside the save queue. Any save that is
// in flight or queued carries a snapshot of canvas.works taken before those rows existed,
// and set_wall_details! destroys every row missing from the payload — so drain the queue
// first, then hold saves for the round trip and drop anything queued during it.
export const addWallToCanvas = (sourceWallId) => (dispatch, getState) => (
  whenSaved().then(() => {
    pauseSaves();
    const { wallId, works: existingWorks } = getState().canvas;
    const previousWorks = [...existingWorks];
    const cachedDetails = getState().workDetails;

    return importWallApi(wallId, sourceWallId).then(({ works, pricing }) => {
      dispatch(redo({
        type: Constants.canvas.setWorks,
        works: previousWorks
      }));
      dispatch({
        type: Constants.canvas.setWorks,
        works
      });
      if (pricing) {
        dispatch({ type: Constants.canvas.setPricing, pricing });
      }
      works.forEach((wp) => {
        if (!cachedDetails[wp.workId]) {
          dispatch(loadWorkDetails(wp.workId));
        }
      });
      dispatch(resetZoom());
      trackEvent('wall builder: add wall from favorites', {
        'wall id': wallId,
        'source wall id': sourceWallId,
        'items count': works.length - previousWorks.length
      });
      resumeSaves();
    }).catch(() => {
      resumeSaves();
      // eslint-disable-next-line no-alert
      alert('Sorry, we could not add that wall. Please try again.');
    });
  })
);
